import React from 'react';
export function Disclaimer({ theme }: { theme: 'dark' | 'light' }) {
  return (
    <section className={`betterMood__disclaimer-${theme}`}>
      <p>
        Disclaimer: The information presented in Better Mood is for
        informational purposes only. It is based on scientific studies (human,
        animal, or in vitro), clinical experience, or traditional usage as
        cited. The results reported may not necessarily occur in all
        individuals. For many of the conditions discussed, treatment with
        prescription medication is also available. Consult your doctor,
        practitioner, and/or pharmacist for any health problem and before making
        any changes in prescribed medications. It could be dangerous to
        immediately cease taking psychiatric drugs because of potential
        significant withdrawal side effects. No one should stop taking any
        psychiatric drug without the advice and assistance of a competent,
        medical doctor.
      </p>
      <p>&copy; 2025 Better Mood. All rights reserved</p>
    </section>
  );
}
